import React, { useContext } from 'react';

// GLOBAL HELPERS
import { ListContext } from 'helpers/getListData';

// BOOTSTRAP COMPONENTS
import { Col, Row } from 'react-bootstrap';

// VARIABLES
export const HEADERS = [
  {
    key:'actual_sold',
    name:'Sold',
    xs: 6
  },
  {
    key:'actual_amfi',
    name:'AM/FI',
    xs: 6
  },
  {
    key:'actual_fallout',
    name:'Fallout',
    xs: 6
  },
  {
    key:'actual_order',
    name:'Order',
    xs: 6
  },
  {
    key:'actual_delivered',
    name:'Delivered',
    xs: 8
  },
  {
    key:'actual_backout',
    name:'Backout',
    xs: 8
  },
  {
    key:'actual_net',
    name:'Net',
    xs: 8
  },
]

// MAIN COMPONENT
const OverviewHeader = () => {
 
  // CONTEXT
  const { data } = useContext(ListContext) || {}; 

  // RENDER
  return(
    <Row className="flex-grow-0 mx-0 mt-lg-4 mb-4 border-top border-right">
      {HEADERS.map(({key, name, xs}, index) => (
        <Col className="border-left border-bottom py-3 flex-grow-1" xs={xs} sm="auto" key={index}>
          <div className="text-muted">{name}</div>
          <div className="mt-3 large fw-bolder text-primary">{data?.[key]}</div>
        </Col>
      ))}
    </Row>
  )
};

export default OverviewHeader